const FIELD_NAMES = {
  PASSWORD: 'password',
};

export default FIELD_NAMES;
